import { InsuranceName, Nullable, VendorInsuranceGrade } from '@orcar/common';
import { INSURANCE_TYPE, simplifyPriceFormat } from '@orcar/common-d2c';

const normalRange = (title?: string, value?: Nullable<string>) => {
  switch (title) {
    case '면책금':
    case '자기부담금(면책금)':
      if (value) return value;
      return '수리비 20% (최저30~50만원)\n면책금 발생';

    case '수리기간 손해 보상금(휴차 보상료)':
    case '휴차 보상료':
      return '발생';

    case '보상 한도':
      if (value) return getInsuranceRangeWithValue(title, value);
      return '200~400만원';

    case '단독 사고':
      return '수리비 발생\n면책금 발생\n휴차 보상료 발생\n(대인/대물/자손 접수시 면책금 인당/건당 각각 발생)';

    case '휠/타이어':
      return '보장불가';
  }
};

const perfectRange = (title?: string, value?: Nullable<string>) => {
  switch (title) {
    case '면책금':
    case '자기부담금(면책금)':
      if (value) return value;
      return '면책금 발생';

    case '휴차 보상료':
    case '수리기간 손해 보상금(휴차 보상료)':
      return '보상 한도 초과 시 발생';

    case '보상 한도':
      if (value) return getInsuranceRangeWithValue(title, value);
      return '300~400만원';

    case '단독 사고':
      return '면책금 발생\n휴차 보상료 발생\n(대인/대물/자손 접수시 면책금 인당/건당 각각 발생)';

    case '휠/타이어':
      return '보장불가';
  }
};

const partialUnlimitedRange = (title?: string) => {
  switch (title) {
    case '자기부담금(면책금)':
    case '면책금':
      return '발생';

    case '보상 한도':
      return '무제한';

    case '수리기간 손해 보상금(휴차 보상료)':
    case '휴차 보상료':
      return '발생';

    case '단독 사고':
      return '보장불가';

    case '휠/타이어':
      return '보장';
  }
};

// 슈퍼자차의 경우엔 일반/고급자차에 따라 보장내용이 다름
const superRange = (title?: string, value?: Nullable<string>) => {
  switch (title) {
    case '면책금':
    case '자기부담금(면책금)':
      if (value) return value;
      return '면책금 발생';

    case '수리기간 손해 보상금(휴차 보상료)':
    case '휴차 보상료':
      return '면제';

    case '보상 한도':
      return '무제한';

    case '단독 사고':
      return '면책금 발생\n(대인/대물/자손 접수시 면책금 인당/건당 각각 발생)';

    case '휠/타이어':
      return '현장출동서비스 (휠, 타이어, 배터리, 차량잠금해제, 견인10KM이내, 1회성 소멸상품)';
  }
};

const getInsuranceRangeWithValue = (title?: string, value?: string) => {
  switch (title) {
    case '면책금':
    case '휴차 보상료':
    case '자기부담금(면책금)':
    case '수리기간 손해 보상금(휴차 보상료)':
      return value;

    case '보상 한도':
      return simplifyPriceFormat(value);
  }
};

export const getCurrentInsuranceRange = (
  title?: string,
  insuranceName?: string,
  value?: Nullable<string>,
) => {
  switch (insuranceName) {
    case INSURANCE_TYPE.NORMAL:
      return normalRange(title, value);
    case INSURANCE_TYPE.PERFECT:
      return perfectRange(title, value);
    case INSURANCE_TYPE.SUPER:
      return superRange(title, value);
    case INSURANCE_TYPE.NONE:
      return '전액 부담';
    default:
      return '';
  }
};

export const getLockInsuranceRange = (
  title?: string,
  type?: string,
  value?: Nullable<string>,
) => {
  switch (type) {
    case INSURANCE_TYPE.NORMAL:
      partialUnlimitedRange(title);
    case INSURANCE_TYPE.PERFECT:
      return superRange(title, value);
    case INSURANCE_TYPE.SUPER:
      return perfectRange(title, value);
    case INSURANCE_TYPE.NONE:
      return perfectRange(title);
    default:
      return '';
  }
};

export const getInsuranceName = (insuranceName?: string) => {
  switch (insuranceName) {
    case INSURANCE_TYPE.NORMAL:
      return '일반자차';
    case INSURANCE_TYPE.PERFECT:
      return '고급자차';
    case INSURANCE_TYPE.SUPER:
    case INSURANCE_TYPE.UNLIMITED:
      return '고급자차 +\n무제한특약';
    case INSURANCE_TYPE.PARTIAL_UNLIMITED:
      return '일반자차 +\n무제한특약';
    case INSURANCE_TYPE.NONE:
      return '보험 미적용';
    case INSURANCE_TYPE.ALL:
    default:
      return '전체';
  }
};

export const getTooltipInfo = (title: string) => {
  switch (title) {
    case '휴차 보상료':
      return '사고 발생 후 차량 수리기간 동안의 영업 손실 비용을 뜻합니다.';
    case '단독 사고':
      return '사고의 상대방이 없는 자동차 사고로, 본인과실 100%이거나 주·정차된 차량을 접촉하는 사고입니다.';
    case '휠/타이어':
      return '차량의 휠 또는 타이어가 파손된 경우로, 보험 보상한도 금액과 관계없이 별도로 수리비용이 발생합니다.';
    default:
      return;
  }
};
